import { Button } from "@/components/button";
import { FONT } from "@/styles/common";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomFlex = styled(Flex)`
    border: 1px solid ${({ theme }) => theme.COLOR.text[300]};
`;

export const CustomText = styled(Text)`
    ${FONT("notoSerif", 14, 400, 1.4)}
`;

export const CustomButton = styled(Button)`
    width: 164px;
    height: 54px;
    padding: 0 36px !important;
    box-sizing: border-box;
    border-radius: 0;
    ${FONT("pretendard", 16, 300, 1.4)}
    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        width: 100%;
        height: 40px;
    }
`;
